import { Container, Row, Col, Card } from 'react-bootstrap';
import { 
  Monitor, 
  Code, 
  Cloud, 
  Megaphone, 
  Brain, 
  BarChart3, 
  Building,
  CheckCircle
} from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { PageBanner } from '../components/layout/PageBanner';
import { Link } from 'react-router-dom'; // ✅ ADDED

const Services = () => {
  const { t, language } = useLanguage();

  const services = [
    {
      icon: Monitor,
      title: t('services.itConsulting'),
      description: t('services.itConsultingDesc'),
      path: "/services/it-consulting", // ✅ ADDED
      features: language === 'hi' 
        ? ['आईटी रणनीति विकास', 'प्रौद्योगिकी रोडमैप', 'डिजिटल परिवर्तन परामर्श', 'आईटी शासन']
        : ['IT Strategy Development', 'Technology Roadmap', 'Digital Transformation Consulting', 'IT Governance']
    },
    {
      icon: Code,
      title: t('services.software'),
      description: t('services.softwareDesc'),
      path: "/services/software-development",
      features: language === 'hi' 
        ? ['कस्टम सॉफ्टवेयर विकास', 'वेब अनुप्रयोग', 'मोबाइल ऐप', 'API एकीकरण']
        : ['Custom Software Development', 'Web Applications', 'Mobile Apps', 'API Integration']
    },
    {
      icon: Cloud,
      title: t('services.cloud'),
      description: t('services.cloudDesc'),
      path: "/services/cloud-devops",
      features: language === 'hi' 
        ? ['क्लाउड माइग्रेशन', 'AWS / Azure सेवाएं', 'DevOps कार्यान्वयन', 'इंफ्रास्ट्रक्चर प्रबंधन']
        : ['Cloud Migration', 'AWS / Azure Services', 'DevOps Implementation', 'Infrastructure Management']
    },
    {
      icon: Megaphone,
      title: t('services.digitalMarketing'),
      description: t('services.digitalMarketingDesc'),
      path: "/services/digital-marketing",
      features: language === 'hi' 
        ? ['SEO अनुकूलन', 'सोशल मीडिया मार्केटिंग', 'कंटेंट रणनीति', 'एनालिटिक्स और रिपोर्टिंग']
        : ['SEO Optimization', 'Social Media Marketing', 'Content Strategy', 'Analytics & Reporting']
    },
    {
      icon: Brain,
      title: t('services.ai'),
      description: t('services.aiDesc'),
      path: "/services/ai",
      features: language === 'hi' 
        ? ['मशीन लर्निंग मॉडल', 'प्राकृतिक भाषा प्रसंस्करण', 'पूर्वानुमान विश्लेषण', 'स्वचालन समाधान']
        : ['Machine Learning Models', 'Natural Language Processing', 'Predictive Analytics', 'Automation Solutions']
    },
    {
      icon: BarChart3,
      title: t('services.erp'),
      description: t('services.erpDesc'),
      path: "/services/erp",
      features: language === 'hi' 
        ? ['ERP कार्यान्वयन', 'प्रक्रिया स्वचालन', 'रिपोर्टिंग डैशबोर्ड', 'डेटा एकीकरण']
        : ['ERP Implementation', 'Process Automation', 'Reporting Dashboards', 'Data Integration']
    },
    {
      icon: Building,
      title: t('services.govEnterprise'),
      description: t('services.govEnterpriseDesc'),
      path: "/services/gov-enterprise",
      features: language === 'hi' 
        ? ['ई-गवर्नेंस समाधान', 'GIGW अनुपालन', 'सुरक्षित प्लेटफॉर्म', 'नागरिक सेवा पोर्टल']
        : ['E-Governance Solutions', 'GIGW Compliance', 'Secure Platforms', 'Citizen Service Portals']
    }
  ];

  return (
    <main id="main-content">
      <PageBanner 
        title={t('services.pageTitle')} 
        breadcrumb={t('services.breadcrumb')} 
      />

      {/* Introduction */}
      <section className="gov-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <p style={{ 
                fontSize: '1.125rem', 
                color: 'hsl(var(--muted-foreground))',
                textAlign: 'center',
                lineHeight: 1.7
              }}>
                {t('services.intro')}
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Services Grid */}
      <section className="gov-section gov-section-alt" style={{ paddingTop: 0 }}>
        <Container>
          <Row className="g-4">
            {services.map((service, index) => (
              <Col key={index} lg={6}>
                <Link 
                  to={service.path} 
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <Card className="gov-card h-100" style={{ cursor: 'pointer' }}>
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-start gap-4">
                        <div 
                          style={{
                            width: '64px',
                            height: '64px',
                            minWidth: '64px',
                            background: 'var(--gradient-accent-subtle)',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <service.icon size={28} style={{ color: 'hsl(var(--primary))' }} />
                        </div>
                        
                        <div className="flex-grow-1">
                          <h3 style={{ 
                            fontSize: '1.125rem', 
                            fontWeight: '600', 
                            marginBottom: '0.75rem',
                            color: 'hsl(var(--foreground))'
                          }}>
                            {service.title}
                          </h3>
                          
                          <p style={{ 
                            fontSize: '0.9375rem', 
                            color: 'hsl(var(--muted-foreground))',
                            marginBottom: '1.25rem',
                            lineHeight: 1.6
                          }}>
                            {service.description}
                          </p>

                          <ul style={{ 
                            listStyle: 'none', 
                            padding: 0, 
                            margin: 0,
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gap: '0.5rem'
                          }}>
                            {service.features.map((feature, fIndex) => (
                              <li 
                                key={fIndex}
                                className="d-flex align-items-center gap-2"
                                style={{ fontSize: '0.8125rem' }}
                              >
                                <CheckCircle 
                                  size={14} 
                                  style={{ 
                                    color: 'hsl(var(--success))',
                                    flexShrink: 0
                                  }} 
                                />
                                <span>{feature}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Process Section (UNCHANGED) */}
      <section className="gov-section">
        <Container>
          <div className="text-center mb-5">
            <h2 className="gov-section-heading">
              {language === 'hi' ? 'हमारी प्रक्रिया' : 'Our Process'}
            </h2>
            <p style={{ color: 'hsl(var(--muted-foreground))' }}>
              {language === 'hi' 
                ? 'आपकी परियोजना को सफल बनाने के लिए हमारा दृष्टिकोण' 
                : 'Our approach to making your project successful'}
            </p>
          </div>

          <Row className="g-4">
            {[
              { step: '01', title: language === 'hi' ? 'परामर्श' : 'Consultation', description: language === 'hi' ? 'आवश्यकताओं को समझना' : 'Understanding requirements' },
              { step: '02', title: language === 'hi' ? 'योजना' : 'Planning', description: language === 'hi' ? 'रणनीति और रोडमैप' : 'Strategy and roadmap' },
              { step: '03', title: language === 'hi' ? 'कार्यान्वयन' : 'Implementation', description: language === 'hi' ? 'विकास और परीक्षण' : 'Development and testing' },
              { step: '04', title: language === 'hi' ? 'सहायता' : 'Support', description: language === 'hi' ? 'निरंतर रखरखाव' : 'Ongoing maintenance' }
            ].map((item, index) => (
              <Col key={index} sm={6} lg={3}>
                <div className="text-center p-4">
                  <div style={{
                    width: '64px',
                    height: '64px',
                    background: 'hsl(var(--primary))',
                    color: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.25rem',
                    fontWeight: '700',
                    margin: '0 auto 1rem'
                  }}>
                    {item.step}
                  </div>
                  <h4 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: '0.875rem', color: 'hsl(var(--muted-foreground))', marginBottom: 0 }}>
                    {item.description}
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Services;